/**
 * @generated SignedSource<<e466071e90ef1151fb499878dd249243>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "feedIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "feeds",
    "variableName": "feedIds"
  },
  {
    "kind": "Literal",
    "name": "severityLevel",
    "value": [
      "SEVERE"
    ]
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveStartDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveEndDate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "srcAlertsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Alert",
        "kind": "LinkedField",
        "name": "alerts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "route",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcAlertsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Alert",
        "kind": "LinkedField",
        "name": "alerts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "route",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "adf86f98e5f2894541758e3f232394e4",
    "id": null,
    "metadata": {},
    "name": "srcAlertsQuery",
    "operationKind": "query",
    "text": "query srcAlertsQuery(\n  $feedIds: [String!]\n) {\n  alerts(severityLevel: [SEVERE], feeds: $feedIds) {\n    route {\n      mode\n      id\n    }\n    effectiveStartDate\n    effectiveEndDate\n    id\n  }\n}\n"
  }
};
})();

node.hash = "14db48cd656497f8fedf6afab9f08383";

module.exports = node;
